module.exports = __webpack_public_path__ + "static/media/loader.eef28b80.gif";